// initial state
const aeState = {
  activeSlide: null,
  activeSlideset: null,
  viewNavItems: [{
      id: 'searchresult',
      img: 'searchresult.svg',
      imgActive: 'searchresult_active.svg',
      imgDisable: 'searchresult_inactive.svg',
      active: false,
      disabled: true,
      label: 'Search result (slide sets)',
      labelDisable: 'no search result available',
      group: 1
    },
    {
      id: 'ss',
      img: 'slideset.svg',
      imgActive: 'slideset_active.svg',
      imgDisable: 'slideset_inactive.svg',
      active: true,
      disabled: false,
      component: 'image-view',
      label: 'slide set',
      labelDisable: '',
      group: 1
    },
    {
      id: 'ss-text',
      img: 'slideset-text.svg',
      imgActive: 'slideset-text_active.svg',
      imgDisable: 'slideset-text_inactive.svg',
      active: false,
      disabled: false,
      label: 'texts (slide set)',
      labelDisable: 'no text in slide set available',
      group: 1
    },
    {
      id: 'ss-relateditems',
      img: 'slideset-relateditems.svg',
      imgActive: 'slideset-relateditems_active.svg',
      imgDisable: 'slideset-relateditems_inactive.svg',
      active: false,
      disabled: false,
      label: 'related items (slide set)',
      labelDisable: 'no related items (slide set) available',
      group: 1
    }, {
      id: 's-objectview',
      img: 'slide-objectview.svg',
      imgActive: 'slide-objectview_active.svg',
      imgDisable: 'slide-objectview_inactive.svg',
      active: false,
      disabled: false,
      label: 'object views',
      labelDisable: 'no image about object views available',
      group: 2
    },
    {
      id: 's-relateditems',
      img: 'slide-relateditems.svg',
      imgActive: 'slide-relateditems_active.svg',
      imgDisable: 'slide-relateditems_inactive.svg',
      active: false,
      disabled: false,
      label: 'related items (slide)',
      labelDisable: 'no related item (slide) available',
      group: 2
    },
    {
      id: 's-details',
      img: 'slide-details.svg',
      imgActive: 'slide-details_active.svg',
      imgDisable: 'slide-details_inactive.svg',
      active: false,
      disabled: false,
      label: 'slide details',
      labelDisable: 'no images about details available',
      group: 2
    },
    {
      id: 's-imageview',
      img: 'slide-imageview.svg',
      imgActive: 'slide-imageview_active.svg',
      imgDisable: 'slide-imageview_inactive.svg',
      active: false,
      disabled: false,
      label: 'screen images',
      labelDisable: 'no screen image available',
      group: 2
    },
    {
      id: 's-text',
      img: 'slide-text.svg',
      imgActive: 'slide-text_active.svg',
      imgDisable: 'slide-text_inactive.svg',
      active: false,
      disabled: false,
      label: 'slide text',
      labelDisable: 'no text available',
      group: 2
    },
    // {
    //   id: 'tool',
    //   img: 'tool.svg',
    //   imgActive: 'tool_active.svg',
    //   imgDisable: 'tool_inactive.svg',
    //   active: false,
    //   disabled: false,
    //   label: 'other',
    //   group: 3
    // },
    // {
    //   id: 'animation',
    //   img: 'animation.svg',
    //   imgActive: 'animation_active.svg',
    //   imgDisable: 'animation_inactive.svg',
    //   active: false,
    //   disabled: false,
    //   label: 'Animation',
    //   group: 3
    // },
    // {
    //   id: 'movie',
    //   img: 'movie.svg',
    //   imgActive: 'movie_active.svg',
    //   imgDisable: 'movie_inactive.svg',
    //   active: false,
    //   disabled: false,
    //   label: 'Video',
    //   group: 3
    // }
  ]
};

// getters
const getters = {
  activeSlideset: state => state.activeSlideset,
  viewNavItems: state => state.viewNavItems,
  activeSlide: state => {
    const sel = state.activeSlide;
    if (!sel && state.activeSlideset) {
      const newSel = state.activeSlideset.slides[0];
      state.activeSlide = newSel;
      return newSel;
    }  
    return sel;
  },
  activeViewGroup: state => {
    return state.viewNavItems.find(a => a.active).group;
  }
};

const gotoImageOfSlide = (slide, key, a) => {
  const images = slide.$_images;
  const active = images.find(img => img.key === key);
  let idx = images.indexOf(active);
  idx = idx + a;
  if (idx >= 0 && idx < images.length) {
    const next = images[idx];
    if (next.dbImageInfo && next.dbImageInfo.name) {
      return next.key;
    } else if (next) {
      return gotoImageOfSlide(slide, next.key, a);
    }
  }
  return;
};

// actions
const actions = {
  ['select.slideset'](store, ss) {
    store.state.activeSlide = null;
    // ss.slides ? '' : ss.querySlides();
    store.state.activeSlideset = ss;
  },

  ['select.navItems'](store, viewIds) {
    if (!viewIds) {
      viewIds = 'ss';
    }
    viewIds = viewIds.split(',');
    store.state.viewNavItems.forEach(v => {
      if (viewIds.indexOf(v.id) >= 0) {
        v.active = true;
      } else {
        v.active = false;
      }
    });
  },
  ['select.thumbnail'](store, o) {
    if (!o) {
      return;
    }
    if (o.type === 'ss') {
      store.dispatch('select.slide', o.document);
    } else if (o.type === 'sl' || o.type === 'slscreen') {
      o.document.$_activeImageKey = o.key;
      store.dispatch('select.slide', o.document);
    }
  },
  ['select.slide'](store, sl) {
    store.state.activeSlide = sl;
  },
  ['select.prevSlideOfSlideset'](store) {
    const ss = store.state.activeSlideset;
    const sl = store.state.activeSlide;
    if (ss && sl && ss.slides) {
      let idx = ss.slides.indexOf(sl);
      if (--idx > -1) {
        store.state.activeSlide = ss.slides[idx];
      }
    }
  },
  ['select.nextSlideOfSlideset'](store) {
    const ss = store.state.activeSlideset;
    const sl = store.state.activeSlide;
    if (ss && sl && ss.slides) {
      let idx = ss.slides.indexOf(sl);
      if (++idx < ss.slides.length) {
        store.state.activeSlide = ss.slides[idx];
      }
    }
  },
  ['select.prevImageOfSlide'](store) {
    const sl = store.state.activeSlide;
    const key = gotoImageOfSlide(sl, sl.$_activeImageKey, -1);
    if (key) {
      sl.$_activeImageKey = key;
    }
  },
  ['select.nextImageOfSlide'](store) {
    const sl = store.state.activeSlide;
    const key = gotoImageOfSlide(sl, sl.$_activeImageKey, 1);
    if (key) {
      sl.$_activeImageKey = key;
    }
  }
};

// mutations
const mutations = {};

export default {
  namespaced: true,
  state: aeState,
  getters,
  actions,
  mutations
};
